import { Component, OnDestroy, OnInit } from '@angular/core';
import { EMPTY, Subscription } from 'rxjs';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { AudienceCapacityService } from 'src/app/services/audience-services/audience-capacity-service/audience-capacity.service';
import { DashboardService } from 'src/app/services/dashboard-services/dashboard.service';

@Component({
  selector: 'app-audience-capacity',
  templateUrl: './audience-capacity.component.html',
  styleUrls: ['./audience-capacity.component.scss']
})
export class AudienceCapacityComponent implements OnInit, OnDestroy {

  capacityData;

  centers;
  selectedCenters = [];
  from;
  to;

  colors = [
    '#3bafda',
    '#ed5565',
    '#fcbb42',
    '#37bc9b',
    '#967adc',
    '#d770ad',
    '#ff9d00',
    '#75560d',
    '#ffe4b5',
    '#eeeeee',
    '#6d7182',
  ];

  getCapacitySubscription: Subscription;
  dashboardServiceSubscription: Subscription;

  constructor(
    private headerBreadcrumbService: HeaderBreadcrumbService,
    private userStorageService: UserStorageService,
    private audienceCapacityService: AudienceCapacityService,
    private dashboardService: DashboardService,
    private snackbarService: SnackBarService
  ) {
    this.centers = this.userStorageService.getCenterList();
   }


  ngOnInit() {
    this.setBreadcrumb();
    // this.selectedCenters = [this.centers[0]];
    if (this.dashboardServiceSubscription) { this.dashboardServiceSubscription.unsubscribe(); }
    this.dashboardServiceSubscription = this.dashboardService.listenReloadStatistics().pipe(
      tap(o => this.selectedCenters = o['centers']),
      tap(o => this.from = o['from'].valueOf()),
      tap(o => this.to = o['to'].valueOf()),
      tap(o => this.loadData())
    ).subscribe();
  }

  private loadData() {
    this.capacityData = null;
    this.getCapacity();
  }

  private getCapacity() {
    const centerInternalIdList = this.selectedCenters.map( center => center.InternalId );
    this.getCapacitySubscription = this.audienceCapacityService.getCapacity(
      this.from,
      this.to,
      centerInternalIdList
    ).pipe(
      tap(o => this.capacityData = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-th', 'breadcrumb-title.audience capacity'));
  }

  ngOnDestroy() {
    if (this.dashboardServiceSubscription) { this.dashboardServiceSubscription.unsubscribe(); }
    if (this.getCapacitySubscription) { this.getCapacitySubscription.unsubscribe(); }
  }

}

